import React from 'react';
import {parse, addMinutes} from 'date-fns';

import LegHeader from './LegHeader';
import LegBody from './LegBody';
import TransitBadge from '../TransitBadge';
import { durationInWords, distanceInWords } from '../../../utils/directionsUtilities';

//const DEFAULT_STOP = 'DEFAULT';
const FLAG_STOP = 'FLAG_STOP';
const DEVIATED_STOP = 'DEVIATED';
const MUST_PHONE = 'mustPhone';

const TripLeg = props => {
    const { idx } = props;
    // console.log('Im props details ', props.details);
    if (idx === 0) {
        return renderStartingDirections(props.details);
    }
    return renderDirections(props.details);
};


const renderStartingDirections = details => {
    const { from, to } = details;
    const today = new Date();
    const agencyOffset = details.agencyTimeZoneOffset / (60 * 1000);
    const timezoneDiff = agencyOffset + today.getTimezoneOffset();
    const startTime = addMinutes(parse(details.startTime), timezoneDiff);
    const toTime = to.departure ? to.departure : to.arrival;
    const endTime = addMinutes(parse(toTime), timezoneDiff);

    return(
        <>
            <LegHeader
                time={startTime}
                heading={from.name}
            />
            <LegBody
                details={details}
                text={getTripText(details)}
            />
            <LegHeader
                time={endTime}
                heading={to.name}
            />
        </>
    );
};

const renderDirections = details => {
    const { from, to } = details;
    const today = new Date();
    const agencyOffset = details.agencyTimeZoneOffset / (60 * 1000);
    const timezoneDiff = agencyOffset + today.getTimezoneOffset();
    const toTime = to.departure ? to.departure : to.arrival;
    const endTime = addMinutes(parse(toTime), timezoneDiff);
    if (from.stopId === to.stopId) {
        return null;
    }
    return (
        <>
            <LegBody
                details={details}
                text={getTripText(details)}
            />
            <LegHeader
                time={endTime}
                heading={to.name}
            />
        </>
    );
};


const getTripText = details => {
    if (details.mode === 'WALK') {
        return getWalkingTripText(details);
        
    } else {
        return getTransitTripText(details);
    }
};

const getWalkingTripText = details => {
    const { distance, duration } = details;
    return (
        <>
            Walk {distanceInWords(distance)} ({durationInWords(duration)})
        </>
    );
};

const getTransitTripText = details => {
    const { agencyUrl, agencyName, headsign, interlineWithPreviousLeg } = details;
    const boardingAction = interlineWithPreviousLeg ? 'Continue on' : 'Board';
    return (
        <>
            {getFromFlexText(details)}
            {getFromFlex2Text(details)}
            <div className="otp-boarding-details">
                {boardingAction} <TransitBadge leg={details} />{headsign && <span className="otp-headsign">toward {headsign}</span>}
            </div>
            <div className="otp-service-info">
                Service provided by <a href={agencyUrl}>{agencyName}</a>
            </div>
            {getToFlexText(details)}
            {getToFlex2Text(details)}
        </>
    );
};

const getFromFlexText = details => {
    const { from } = details;
    if (from.boardAlightType === FLAG_STOP) {
        return (
            <div className="otp-flex-message otp-pickup-message">
                {details.flexFlagStopPickupMessage}
            </div>
        );
    }
    if (from.boardAlightType === DEVIATED_STOP) {
        return (
            <div className="otp-flex-message otp-pickup-message">
                {details.flexDrtPickupMessage}             
                
            </div>
        );
    }
    return '';
};

const getFromFlex2Text = details => {
    // console.log(details.boardRule, MUST_PHONE);
    if (window.otpConfig.flex2) {
        if (details.boardRule === MUST_PHONE) {
            return (
                <div className="otp-flex-message otp-pickup-message">
                    {details.pickupBookingInfo.message}

                </div>
            );
        }
        return '';
    }
};


const getToFlexText = details => {
    const { to, callAndRide } = details;
    if (to.boardAlightType === FLAG_STOP) {
        return (
            <div className="otp-flex-message otp-dropoff-message">
                {details.flexFlagStopDropOffMessage}
            </div>
        );
    }
    if (to.boardAlightType === DEVIATED_STOP) {
        if (callAndRide && callAndRide === true) {
            return '';
        }
        return (
            <div className="otp-flex-message otp-dropoff-message">
                {details.flexDrtDropOffMessage}
            </div>
        );
    }
    return '';
};

const getToFlex2Text = details => {
    // console.log(details.boardRule, MUST_PHONE);
    if (window.otpConfig.flex2) {
        if (details.boardRule === MUST_PHONE) {
            return (
                <div className="otp-flex-message otp-dropoff-message">
                    {details.dropOffBookingInfo.message}
                </div>
            );
        }
        return '';
    }
};
export default TripLeg;
